/**
 * Обробка кнопок навігації каруселі для collection-list секції
 * Кнопки винесені з каруселі і потребують спеціальної обробки
 */
(function() {
  'use strict';

  /**
   * Ініціалізація кнопок навігації для конкретної секції
   * @param {string} sectionId - ID секції
   */
  function initCarouselButtons(sectionId) {
    const section = document.querySelector('.' + sectionId);
    if (!section) return;

    const carousel = section.querySelector('carousel-slider');
    const prevBtn = section.querySelector('button[name="prev"][data-carousel-target="' + sectionId + '"]');
    const nextBtn = section.querySelector('button[name="next"][data-carousel-target="' + sectionId + '"]');

    if (!carousel || (!prevBtn && !nextBtn)) return;

    // Очікуємо, поки carousel-slider ініціалізується
    const initButtons = () => {
      if (!carousel.hasAttribute('loaded')) {
        setTimeout(initButtons, 100);
        return;
      }

      // Знаходимо nav елемент всередині carousel-slider
      const nav = carousel.querySelector('.slider-nav');
      if (!nav) {
        // Якщо nav немає, спробуємо через деякий час
        setTimeout(initButtons, 100);
        return;
      }

      // Обробник для кнопки "Назад"
      if (prevBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          // Створюємо тимчасову кнопку для делегування події
          const tempBtn = document.createElement('button');
          tempBtn.name = 'prev';
          tempBtn.className = 'slider-nav__btn';
          nav.appendChild(tempBtn);
          
          // Викликаємо нативний click на тимчасовій кнопці
          // Це спрацює обробник делегування подій на nav елементі
          tempBtn.click();
          
          // Видаляємо тимчасову кнопку після невеликої затримки
          setTimeout(() => {
            if (nav.contains(tempBtn)) {
              nav.removeChild(tempBtn);
            }
          }, 100);
        });
      }

      // Обробник для кнопки "Вперед"
      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          // Створюємо тимчасову кнопку для делегування події
          const tempBtn = document.createElement('button');
          tempBtn.name = 'next';
          tempBtn.className = 'slider-nav__btn';
          nav.appendChild(tempBtn);
          
          // Викликаємо нативний click на тимчасовій кнопці
          // Це спрацює обробник делегування подій на nav елементі
          tempBtn.click();
          
          // Видаляємо тимчасову кнопку після невеликої затримки
          setTimeout(() => {
            if (nav.contains(tempBtn)) {
              nav.removeChild(tempBtn);
            }
          }, 100);
        });
      }

      // Синхронізуємо стан кнопок
      const updateButtonStates = () => {
        const internalPrevBtn = carousel.querySelector('button[name="prev"]');
        const internalNextBtn = carousel.querySelector('button[name="next"]');
        if (prevBtn && internalPrevBtn) {
          prevBtn.disabled = internalPrevBtn.disabled;
        }
        if (nextBtn && internalNextBtn) {
          nextBtn.disabled = internalNextBtn.disabled;
        }
      };

      // Оновлюємо стан кнопок при скролі
      const slider = carousel.querySelector('.slider');
      if (slider) {
        slider.addEventListener('scroll', () => {
          setTimeout(updateButtonStates, 100);
        });
      }

      // Початкове оновлення стану
      setTimeout(updateButtonStates, 500);
    };

    initButtons();
  }

  // Ініціалізація для всіх секцій collection-list на сторінці
  function initAllCarouselButtons() {
    const sections = document.querySelectorAll('[class*="section-id-"].collection-slider-row');
    sections.forEach(section => {
      const classList = Array.from(section.classList);
      const sectionIdClass = classList.find(cls => cls.startsWith('section-id-'));
      if (sectionIdClass) {
        initCarouselButtons(sectionIdClass);
      }
    });
  }

  // Ініціалізація при завантаженні DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarouselButtons);
  } else {
    initAllCarouselButtons();
  }

  // Також ініціалізуємо при динамічному додаванні контенту
  if (typeof window.initLazyScript !== 'undefined') {
    const originalInitLazyScript = window.initLazyScript;
    window.initLazyScript = function(element, callback) {
      originalInitLazyScript(element, callback);
      if (element && element.classList && element.classList.contains('collection-slider-row')) {
        const classList = Array.from(element.classList);
        const sectionIdClass = classList.find(cls => cls.startsWith('section-id-'));
        if (sectionIdClass) {
          setTimeout(() => initCarouselButtons(sectionIdClass), 100);
        }
      }
    };
  }
})();

